module.exports = __webpack_public_path__ + "img/homepage_banner.asset.25b7bb31.png";